
import React, { useState, useRef, useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";

function Header({ onLogout, onClearChat, userName }) {
  const [showLogout, setShowLogout] = useState(false);
  const dropdownRef = useRef(null);

  const handleAvatarClick = () => {
    setShowLogout((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowLogout(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="header"
      style={{ backgroundImage: "url('/assets/navbg.jpg')" }}
    >
      <div className="header-user">
        <div className="logoWrapper">
          <img src="/assets/logo.png" alt="Logo" className="logo" />
        </div>
        <div className="line"></div>
        {/* <span className="logo-name">AI Foundry</span>
        <div className="line2"></div> */}
        <span className="logo-name">Genalytix</span>
      </div>

      <div className="header-user">
        <span className="user-name">{userName || "User"}</span>

        <div
          className="avatar-container"
          style={{ position: "relative" }}
          ref={dropdownRef} // 👈 attach ref here
        >
          <FaUserCircle
            size={30}
            className="user-avatar"
            onClick={handleAvatarClick}
            style={{ cursor: "pointer", color: "#888" }}
          />

          {showLogout && (
            <div className="dropdown-menu">
              <ul>
                <li className="logoutBtn" onClick={onLogout}>
                  Logout
                </li>
              </ul>
              <ul>
                <li
                  onClick={() => {
                    onClearChat();
                    setShowLogout(false);
                  }}
                >
                  Clear Chat
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
